import HttpService from './HttpService';

const TanksApi = HttpService('/api/tanks/');
const doPost = (action, data) => TanksApi.post(action, data);
const doGet = (url) => TanksApi.get(url);
const doDelete = (url) => TanksApi.delete(url);

export default {
  getTanksWithCurrentStatus(activeSiteId) {
    const apiAction = 'GetTanksWithCurrentStatus';
    const queryString = `activeSiteId=${activeSiteId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  getVesselTanks(activeSiteId) {
    const apiAction = 'GetVesselTanks';
    const queryString = `activeSiteId=${activeSiteId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  getTankDetails(tankId) {
    const apiAction = 'GetTankDetails';
    const queryString = `tankId=${tankId}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  createTank(tank) {
    const apiAction = 'CreateTank';
    return doPost(apiAction, tank);
  },
  updateTank(tankUpdate) {
    const apiAction = 'UpdateTank';
    return doPost(apiAction, tankUpdate);
  },
  deleteTank(id) {
    const apiAction = 'DeleteTank';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
  createTankStatus(tankStatus) {
    const apiAction = 'CreateManualTankStatus';
    return doPost(apiAction, tankStatus);
  },
  deleteTankStatus(id) {
    const apiAction = 'DeleteManualTankStatus';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },

};
